import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { amplitudeService } from './services/amplitude.service'

// Initialize Amplitude Analytics
amplitudeService.initialize().catch((error) => {
  console.error('Failed to initialize Amplitude:', error)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
